/**
 * Look through HTML and convert any URLs into proper links.
 */
angular.module('hjApp').filter('urlsToLinks', [
    function () {
        return function (html) {
            if (typeof html !== 'undefined') {
                if (isNaN(html)) {
                    return Autolinker.link(html, { newWindow: true, stripPrefix: false });
                } else {
                    return html;
                }
            }
        };
    }
]);
